var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectPackingIndex >= 0)?_c('div',{staticClass:"twoColumn"},[_c('tw-process-group-list-preview-goods-line-packing-item',{attrs:{"selectGoodsIndex":_vm.selectPackingIndex}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }